// extracted by mini-css-extract-plugin
export default {"teaserGrid":"TeaserList_teaserGrid__FH6Sj"};